import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import mutations from './mutations';
import actions from './actions';
import {STORAGE_KEY} from '../settings/storage';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: STORAGE_KEY,
  storage: window.localStorage
});

export default new Vuex.Store({
  state: {
    user: {
      authToken: null,
      info: null
    }
  },
  mutations,
  actions,
  modules: {
  },
  plugins: [vuexLocal.plugin],
})
